module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600-d01ac68c4747e41a359cd94cecc29f9f.woff2";